export { default } from './CardHeader';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardHeader/index.js
// module id = 660
// module chunks = 0